import {
  FETCH_PROJECTS_REQUEST,
  FETCH_PROJECTS_SUCCESS,
  FETCH_PROJECTS_FAILURE,
  FETCH_PROJECT_REQUEST,
  FETCH_PROJECT_SUCCESS,
  FETCH_PROJECT_FAILURE,
  UPDATE_PROJECTS_REQUEST,
  UPDATE_PROJECTS_FAILURE,
  UPDATE_PROJECTS_SUCCESS,
  DELETE_PROJECTS_REQUEST,
  DELETE_PROJECTS_FAILURE,
  DELETE_PROJECTS_SUCCESS,
  RESET_PROJECT_ADDED,
  CLEAR_PROJECT_ERRORS,    // Nouvelles imports
  CLEAR_PROJECT_SUCCESS,
} from './actionTypes';

const initialState = {
  projects: [],
  project: null,
  loadingProject: false,
  errorProject: null,
  projectAdded: null
};

const Projects = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROJECTS_REQUEST:
      return {
        ...state,
        loadingProject: true,
        errorProject: null,
        projectAdded: false
      };
    case FETCH_PROJECTS_SUCCESS:
      return {
        ...state,
        loadingProject: false,
        projects: action.payload,
      };
    case FETCH_PROJECTS_FAILURE:
      return {
        ...state,
        loadingProject: false,
        errorProject: action.payload,
      };
    case FETCH_PROJECT_REQUEST:
      return {
        ...state,
        loadingProject: true,
        errorProject: null,
        projectAdded: false
      };
    case FETCH_PROJECT_SUCCESS:
      return {
        ...state,
        loadingProject: false,
        project: action.payload,
      };
    case FETCH_PROJECT_FAILURE:
      return {
        ...state,
        loadingProject: false,
        errorProject: action.payload,
      };
    case UPDATE_PROJECTS_REQUEST:
      return {
        ...state,
        loadingProject: true,
        errorProject: null,
        projectAdded: false
      };
    case UPDATE_PROJECTS_SUCCESS:
      return {
        ...state,
        loadingProject: false,
        project: null,
        projectAdded: true
      };
    case UPDATE_PROJECTS_FAILURE:
      return {
        ...state,
        loadingProject: false,
        errorProject: action.payload,
      };
    case DELETE_PROJECTS_REQUEST:
      return {
        ...state,
        loadingProject: true,
        errorProject: null,
        projectAdded: false
      };
    case DELETE_PROJECTS_SUCCESS:
      return {
        ...state,
        projectAdded: true,
        loadingProject: false,
        projects: state.projects.filter(project => project.id !== action.payload),
      };
    case DELETE_PROJECTS_FAILURE:
      return {
        ...state,
        loadingProject: false,
        errorProject: action.payload,
      };
    case RESET_PROJECT_ADDED:
      return {
        ...state,
        projectAdded: false
      };
    case CLEAR_PROJECT_ERRORS:
      return {
        ...state,
        errorProject: null,
      };
    case CLEAR_PROJECT_SUCCESS:
      return {
        ...state,
        projectAdded: null,
      };
      
    default:
      return state;
  }
};

export default Projects;